/**
 * Opções compartilhadas pelos formulários de captura de lead (modal e calculadora ROI)
 * + helper de identificador único universal (`dgennyLeadId`).
 *
 * Os enums abaixo refletem as opções do EspoCRM (entidade Opportunity, campos
 * `cErp` e `cQtdeCompradores`). Mudanças aqui exigem mudança correspondente
 * no Admin do EspoCRM, e vice-versa — caso contrário, o submit retorna 400.
 */

export const ERP_OPTIONS = [
  'Sienge',
  'TOTVS',
  'Senior',
  'Mega',
  'UAU',
  'Obra Prima',
  'Gestor de Obras',
  'Não utilizamos ERP',
  'Outro',
] as const;
export type ErpOption = typeof ERP_OPTIONS[number];

export const BUYER_TEAM_SIZE_OPTIONS = [
  'Não temos time de compras',
  '1 a 2 compradores',
  '3 a 5 compradores',
  '6 a 10 compradores',
  'Acima de 10 compradores',
] as const;
export type BuyerTeamSize = typeof BUYER_TEAM_SIZE_OPTIONS[number];

/** Converte número exato (calculadora ROI) para a faixa do EspoCRM. */
export function numberToBuyerTeamBucket(n: number): BuyerTeamSize {
  if (!Number.isFinite(n) || n <= 0) return 'Não temos time de compras';
  if (n <= 2) return '1 a 2 compradores';
  if (n <= 5) return '3 a 5 compradores';
  if (n <= 10) return '6 a 10 compradores';
  return 'Acima de 10 compradores';
}

const DGENNY_LEAD_ID_KEY = 'dgenny_lead_id';

/**
 * Lê o UUID universal do lead do localStorage; cria um novo se não existir.
 * Resiliente a AdBlock/Safari incognito (gera UUID descartável quando localStorage falha).
 */
export function getOrCreateDgennyLeadId(): string {
  try {
    const existing = window.localStorage.getItem(DGENNY_LEAD_ID_KEY);
    if (existing) return existing;
    const fresh = crypto.randomUUID();
    window.localStorage.setItem(DGENNY_LEAD_ID_KEY, fresh);
    return fresh;
  } catch {
    return crypto.randomUUID();
  }
}
